import { CSSProperties, FC } from 'react';

type Props = {
  size?: number;
  style?: CSSProperties;
  grey?: boolean;
};

const GradientAiIcon: FC<Props> = ({ size = 16, style, grey = false }) => {
  const fill = grey ? 'currentColor' : 'url(#aiIconGradient)';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden="true"
      style={{ color: grey ? '#9e9e9e' : undefined, ...style }}
    >
      {!grey && (
        <defs>
          <linearGradient
            id="aiIconGradient"
            x1="10.0002"
            y1="0.832031"
            x2="10.0002"
            y2="19.1654"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E91E63" />
            <stop offset="1" stopColor="#2196F3" />
          </linearGradient>
        </defs>
      )}
      <path
        fill={fill}
        d="M15.8335 7.4987L16.8752 5.20703L19.1668 4.16536L16.8752 3.1237L15.8335 0.832031L14.7918 3.1237L12.5002 4.16536L14.7918 5.20703L15.8335 7.4987Z"
      />
      <path
        fill={fill}
        d="M15.8335 12.4987L14.7918 14.7904L12.5002 15.832L14.7918 16.8737L15.8335 19.1654L16.8752 16.8737L19.1668 15.832L16.8752 14.7904L15.8335 12.4987Z"
      />
      <path
        fill={fill}
        d="M9.5835 7.91536L7.50016 3.33203L5.41683 7.91536L0.833496 9.9987L5.41683 12.082L7.50016 16.6654L9.5835 12.082L14.1668 9.9987L9.5835 7.91536ZM8.32516 10.8237L7.50016 12.6404L6.67516 10.8237L4.8585 9.9987L6.67516 9.1737L7.50016 7.35703L8.32516 9.1737L10.1418 9.9987L8.32516 10.8237Z"
      />
    </svg>
  );
};

export default GradientAiIcon;
